import { httpClient2 } from 'src/infrastructure/admi-client/http-client';

import { ReaCollectionViewResponseDto, ReaCollectionViewSearchDto } from './rea-collection-view.dto';

export const admiReaCollectionViewService = {
    /**
     * Spring is 0-indexed; the UI is 1-indexed. Convert here so the page state
     * stays 1-indexed end-to-end in components.
     */
    getReaCollectionView: async (search: ReaCollectionViewSearchDto): Promise<ReaCollectionViewResponseDto> => {
        // axios serializes arrays per-element by default (informationAvailabilityStatus=A&informationAvailabilityStatus=B),
        // which is exactly what Spring's @RequestParam List<T> expects, so we can
        // just pass the array through.
        const params: Record<string, string | number | string[]> = {
            page: Math.max(search.page - 1, 0),
            size: search.size,
            sort: search.sort,
        };
        if (search.region) params.region = search.region;
        if (search.accountManagerId) params.accountManagerId = search.accountManagerId;
        if (search.customerId) params.customerId = search.customerId;
        if (search.customerName) params.customerName = search.customerName;
        if (search.reaName) params.reaName = search.reaName;
        if (search.reaAddress) params.reaAddress = search.reaAddress;
        if (search.connectedServicesCountMin != null) {
            params.connectedServicesCountMin = search.connectedServicesCountMin;
        }
        if (search.connectedServicesCountMax != null) {
            params.connectedServicesCountMax = search.connectedServicesCountMax;
        }
        if (search.informationAvailabilityStatus && search.informationAvailabilityStatus.length > 0) {
            params.informationAvailabilityStatus = search.informationAvailabilityStatus;
        }
        if (search.reaCreatedFrom) params.reaCreatedFrom = search.reaCreatedFrom;
        if (search.reaCreatedTo) params.reaCreatedTo = search.reaCreatedTo;
        if (search.reaUpdatedFrom) params.reaUpdatedFrom = search.reaUpdatedFrom;
        if (search.reaUpdatedTo) params.reaUpdatedTo = search.reaUpdatedTo;
        if (search.missingInformationContains) {
            params.missingInformationContains = search.missingInformationContains;
        }

        const response = await httpClient2.get<ReaCollectionViewResponseDto>('/v1/rea-collection-view', { params });
        return response.data;
    },
};
